<template>
    <label :for="'images[' + $attrs.nr + ']'"
        :class="'flex flex-col items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 js_file_input_preview h-full w-full relative group overflow-hidden ' + $attrs.classlist">
        <div class="flex flex-col items-center justify-center pt-5 pb-6 px-4  text-gray-500 js_skeleton z-[1] w-full h-full transition pointer-events-none"
            :class="[fileUsed || $attrs.currentvalue ? 'opacity-0 group-hover:opacity-100 text-white ' :'']">
            <svg class="w-8 h-8 mb-4 transition" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 20 16">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
            </svg>
            <p class="mb-2 text-sm"  ><span class="font-semibold">Click to upload</span>
            </p>
            <p class="text-xs">SVG, PNG, JPG, WEBP or GIF (Max. 2mb)</p>
            <small class="color-red">{{ $attrs.errors }}</small>
        </div>
        <input :id="'images[' + $attrs.nr + ']'" type="file" :name="'images[]'"
            :accept="$attrs.accept ?? '*'"
            class="hidden" @change="previewFiles" />
        <img v-if="$attrs.currentvalue" :src="$attrs.currentvalue" class="w-full h-full rounded-md object-cover absolute top-0 left-0 z-0 transition hover:blur-md hover:scale-105 hover:brightness-50">
    </label>
</template>
  
<script>
export default {
    data() {
        return {
            fileUsed: false
        };
    },
    methods: {
        previewFiles(e) {
            for (var i = 0; i < e.target.files.length; i++) {
                var file = e.target.files[i];
                $(e.target).parent().find('img').remove();
                var img = document.createElement("img");

                img.classList.add('w-full', 'h-full', 'rounded-md', 'object-cover', 'absolute', 'top-0', 'left-0', 'z-0', 'transition', 'hover:blur-md', 'hover:scale-105', 'hover:brightness-50')
                var fileName = document.createElement("span");
                fileName.innerHTML = file.name;
                var reader = new FileReader();
                reader.onloadend = function () {
                    img.src = reader.result;
                }
                reader.readAsDataURL(file);
                $(e.target).parent().find('input').after(img)
                $(e.target).parent()[0].classList.remove('border-2')
                this.fileUsed = true;
            }
        }
    }
};
</script>